import { EnglishIcon } from 'components/ui-kit/icons/iconComponents/EnglishIcon'
// import { FrenchIcon } from 'components/ui-kit/icons/iconComponents/FrenchIcon'
// import { GermanIcon } from 'components/ui-kit/icons/iconComponents/GermanIcon'
// import { PortugalIcon } from 'components/ui-kit/icons/iconComponents/PortugalIcon'
// import { RussianIcon } from 'components/ui-kit/icons/iconComponents/RussianIcon'
// import { SpanishIcon } from 'components/ui-kit/icons/iconComponents/SpanishIcon'
import { IndonesianIcon } from 'components/ui-kit/icons/iconComponents/IndonesianIcon'

/* ==========================================================================
  LANGUAGES
  ========================================================================== */
const LANGUAGES = [
  { label: 'English', languageCode: 'en', flag: EnglishIcon },
  // { label: 'German', languageCode: 'de', flag: GermanIcon },
  // { label: 'Spanish', languageCode: 'es', flag: SpanishIcon },
  // { label: 'French', languageCode: 'fr', flag: FrenchIcon },
  // { label: 'Portuguese', languageCode: 'pt', flag: PortugalIcon },
  // { label: 'Russian', languageCode: 'ru', flag: RussianIcon },
  { label: 'Indonesian', languageCode: 'id', flag: IndonesianIcon }
]

/* ==========================================================================
  HTTP Method Types
========================================================================== */
const METHOD_TYPES = {
  get: 'get',
  post: 'post',
  put: 'put',
  delete: 'delete',
  patch: 'patch'
}

/* ==========================================================================
  Transaction types
========================================================================== */
export const TRANSACTION_TYPES = {
  BET: 'bet',
  WIN: 'win',
  ROLLBACK: 'rollback',
  OUTSTANDING: 'outstanding'
}

/* ==========================================================================
LocalStorage / Cookie data
========================================================================== */
const TOKEN = 'admin_authtoken'
const LANGUAGE = 'admin_language'
const ADMIN_ID = 'admin_id'
const ROLE = 'operator_role'

/* ==========================================================================
Operator Roles
========================================================================== */
const OPERATOR_ROLES = {
  operator: 'OPERATOR',
  operatorUser: 'OPERATOR_USER'
}

/* ==========================================================================
Loader types
========================================================================== */
const LOADER_TYPE = {
  SCALE: 'scale',
  PULSE: 'pulse'
}

/* ==========================================================================
  TOASTER / NOTIFICATION Types
========================================================================== */
const TOASTER_TYPE = {
  success: 'success',
  error: 'error',
  warning: 'warning',
  info: 'info'
}

/* ==========================================================================
  Loader Types
========================================================================== */
const LOADER_HANDLER_TYPES = {
  page: 'pageLoader',
  submit: 'submitButtonLoader',
  table: 'tableLoader'
}

/* ==========================================================================
  Table Cell Type
========================================================================== */
const TABLE_CELL_TYPE = {
  status: 'status',
  switch: 'switch',
  button: 'button',
  date: 'date',
  datetime: 'datetime',
  text: 'text',
  number: 'number',
  default: 'default',
  select: 'select',
  updateIconButton: 'updateIconButton',
  deleteIconButton: 'deleteIconButton',
  actionCell: 'actionCell',
  enableDisable: 'enableDisable',
  render: 'render'
}

/* ==========================================================================
  All the navigation route Paths
========================================================================== */
// const gamesSectionParentRoute = '/games'
// const playersSectionParentRoute = '/players'
// const performanceSectionParentRoute = '/performance'

const ROUTE_PATHS = {
  rootPath: '/',
  login: '/login',
  changePassword: '/change-password',
  resetPassword: '/reset-password/:adminId/:token',
  settings: '/settings',
  dashboard: '/dashboard',
  dailyStatistics: '/daily-statistics',
  gameSettings: '/game-settings',
  gameList: '/games-settings/list',
  editGameSettings: '/game-settings/edit',
  users: '/users',
  transactions: '/transactions',
  gameReports: '/game-reports/',
  notFound: '/not-found',
  operatorSetting: '/operator-setting',
  rightAccess: '/right-access',
  ipWhitelist: '/ip-whitelist',
  auditLogs: '/audit-logs',
  gamesListLogs: '/games-list-logs',
  operatorSettingLogs: '/operator-setting-logs',
  rightAccessLogs: '/right-access-logs',
  ipWhitelistLogs: '/ip-whitelist-logs',
  playerOnline: '/player-online',
  adminUsersLogs: '/admin-users-logs'
}

/* ==========================================================================
  DIALOG Types
========================================================================== */
const DIALOG_TYPE = {
  add: 'add',
  update: 'update',
  delete: 'delete',
  view: 'view',
  hide: ''
}

/* ==========================================================================
  Miscellaneous Constants
========================================================================== */
export const DEFAULT_PAGE_NO = 1
export const DEFAULT_CURRENCY_ID = 1
export const DEFAULT_CURRENCY_NAME = 'Indonesian Rupiah'
export const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD'

const DEFAULT_GAME_ID = {
  CRASH: 1,
  PYRAMID_PLINKO: 6,
  KENO: 7,
  DICE: 8,
  HILO: 10,
  GONGA_MINE: 14,
  COIN_FLIP: 17,
  CROSS: 23,
  TOWER: 24,
  SEXY_RUSH: 25

}

// Export All constant variables
export {
  TOASTER_TYPE,
  LANGUAGES,
  TOKEN,
  LANGUAGE,
  ADMIN_ID,
  ROLE,
  OPERATOR_ROLES,
  ROUTE_PATHS,
  LOADER_TYPE,
  METHOD_TYPES,
  LOADER_HANDLER_TYPES,
  TABLE_CELL_TYPE,
  DIALOG_TYPE,
  DEFAULT_GAME_ID
}

export const REPORTS_TITLE = Object.freeze({
  CRASH: 'Crash',
  KENO: 'Keno',
  DICE: 'Dice',
  HILO: 'HiLo',
  COIN_FLIP: 'Coin Flip',
  PYRAMID_PLINKO: 'Pyramid Plinko',
  GONGA_MINE: 'Gonga Mine',
  CROSS: 'Cross',
  TOWER: 'Tower',
  SEXY_RUSH: 'SEXY RUSH'

})

export const maxOddGameId = ['1', '8', '10', '14', '17', '23', '24', '25']
export const minOddGameId = ['1', '8', '10', '14', '17', '23', '24', '25']
export const houseEdgeGameId = ['1', '6', '7', '8', '10', '14', '17', '23', '24', '25']
export const minAutoRateGameId = ['1']
export const advanceModeRulesGameId = ['24']
